export const analyticsScopeLabel = (scope: string): string => ({
  system: 'LognAI',
  company: 'Company',
  private: 'Only me',
  all: 'All',
}[scope] ?? scope);

export const businessLabel = (value: string): string => {
  const name = value.split('.').pop() ?? value;
  return name.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
};

/**
 * A zero result is only a "good" outcome when every measure in the analysis is a
 * risk/exposure measure (`goodDirection: 'down'` in the semantic catalog).
 * Zero throughput or zero revenue must never be presented as a success.
 */
export const zeroIsPositive = (
  catalog: Record<string, { measures: Record<string, { goodDirection?: 'up' | 'down' | 'neutral' }> }> | undefined,
  analysis: { view: string; measures: string[] } | undefined,
): boolean => {
  if (!catalog || !analysis?.measures.length) return false;
  const measures = catalog[analysis.view]?.measures;
  if (!measures) return false;
  return analysis.measures.every((member) => measures[member]?.goodDirection === 'down');
};

export const userFacingAnalyticsError = (
  cause: unknown,
  fallback = 'The analysis could not be completed. Please try again.',
): string => {
  const message = cause instanceof Error ? cause.message : String(cause ?? '');
  if (!message) return fallback;
  if (/cube|semantic|member|query|sql|schema|reporting|gemini|deterministic|http\s*\d+/i.test(message)) return fallback;
  return message;
};
